import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// AOS (Scroll Animations)
import AOS from "aos";
import "aos/dist/aos.css";

// Initialize AOS before rendering
AOS.init({
  duration: 900,
  once: true,
  easing: "ease-out-cubic",
  offset: 50, // Start animation a bit earlier
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring (optional)
reportWebVitals();
